<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Reboot" icon="↺" color="#dc2626">
        <p class="text-gray-400 italic">Restarts the device</p>
    </NodeBase>
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { Handle, Position } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

defineProps({ id: String, data: Object });
</script>
